import { FONTS } from '../components/sections/theme.js';

export const primaryColor = '#5124A6';

const themeColors = {
    primary: {
        main: primaryColor,
    },
    secondary: {
        main: '#49DEFF',
    },
    common: {
        grey: '#9C9AA7',
        black1e: '#1E1E1E',
        white: '#FFFFFF',
        link: '#2C64E8',
        disabled: '#999999',
        info: '#28B0EA',
    },
};

export const themeConfig = {
    palette: themeColors,
    typography: {
        fontFamily: FONTS.sans,
        h1: {
            color: themeColors.common.black1e,
            fontSize: 48,
            fontWeight: 700,
            fontFamily: FONTS.sans,
            '@media (max-width:767px)': {
                fontSize: 29,
            },
        },
        h2: {
            color: themeColors.common.black1e,
            fontSize: 30,
            fontWeight: 700,
            fontFamily: FONTS.sans,
            '@media (max-width:767px)': {
                fontSize: 20,
            },
        },
        h3: {
            color: themeColors.common.black1e,
            fontSize: 24,
            fontWeight: 700,
            fontFamily: FONTS.sans,
        },
        h4: {
            color: themeColors.common.black1e,
            fontSize: 40,
            fontWeight: 700,
            fontFamily: FONTS.sans,
            lineHeight: '48px',
            '@media (max-width:767px)': {
                fontSize: 26,
                lineHeight: '31px',
            },
        },
        var700x40: {
            color: themeColors.common.black1e,
            fontSize: 40,
            fontWeight: 700,
            lineHeight: 1.5,
            fontFamily: FONTS.sans,
            '@media (max-width:767px)': {
                fontSize: 26,
                lineHeight: '31px',
            },
        },
        var700x32: {
            color: themeColors.common.black1e,
            lineHeight: '48px',
            fontSize: 32,
            fontWeight: 700,
            fontFamily: FONTS.sans,
        },
        var500x18: {
            color: themeColors.common.black1e,
            fontSize: 18,
            fontWeight: 500,
            lineHeight: 1.5,
            fontFamily: FONTS.sans,
        },
        highlightArticle: {
            color: themeColors.common.white,
            fontSize: 16,
            fontWeight: 800,
            fontFamily: FONTS.sans,
            backgroundColor: themeColors.primary.main,
        },
        highlightDate: {
            color: themeColors.common.black1e,
            fontSize: 16,
            fontWeight: 400,
            fontFamily: FONTS.sans,
        },
        bodyArticle: {
            color: '#2C64E8',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '21px',
            fontFamily: FONTS.sans,
        },
        bodyArticle2: {
            color: themeColors.common.black1e,
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '18px',
            fontFamily: FONTS.sans,
        },
        body1: {
            color: themeColors.common.black1e,
            fontSize: 18,
            fontWeight: 600,
            lineHeight: '22px',
            fontFamily: FONTS.sans,
        },
        body2: {
            color: themeColors.common.white,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '19px',
            fontFamily: FONTS.sans,
            '@media (max-width:767px)': {
                fontSize: 12,
                lineHeight: '18px',
            },
        },
        body3: {
            cursor: 'pointer',
            textDecoration: 'none',
            color: '#1E1E1E',
            fontWeight: '700',
            fontSize: 14,
            lineHeight: '21px',
            fontFamily: FONTS.sans,
        },
        body6: {
            color: themeColors.common.black1e,
            fontSize: 18,
            fontWeight: 400,
            lineHeight: '22px',
            fontFamily: FONTS.sans,
        },
        body7: {
            color: '#232127',
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '20px',
            fontFamily: FONTS.sans,
            '@media (max-width:767px)': {
                fontSize: 14,
            },
        },
        body8: {
            color: '#232127',
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '22px',
            fontFamily: FONTS.sans,
        },
        body9: {
            color: themeColors.common.link,
            fontSize: 20,
            fontWeight: 700,
            fontFamily: FONTS.sans,
        },
        body10: {
            color: themeColors.common.black1e,
            fontSize: 16,
            fontWeight: 700,
            lineHeight: '120%',
            fontFamily: FONTS.sans,
        },
        body11: {
            color: themeColors.common.black1e,
            fontSize: 22,
            fontWeight: 700,
            lineHeight: '130%',
            fontFamily: FONTS.sans,
            '@media (max-width:767px)': {
                fontSize: 16,
            },
        },
        subtitle1: {
            color: themeColors.common.black1e,
            fontSize: 16,
            fontWeight: 400,
            fontFamily: FONTS.sans,
        },
        subtitle: {
            color: themeColors.common.black1e,
            fontSize: 18,
            fontWeight: 400,
            lineHeight: '22px',
            fontFamily: FONTS.sans,
        },
        link: {
            color: themeColors.common.link,
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '22px',
            fontFamily: FONTS.sans,
            cursor: 'pointer',
            textDecoration: 'none !important',
        },
    },
    components: {
        MuiButton: {
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        fontWeight: 600,
                        textTransform: 'none',
                    },
                },
                {
                    props: { variant: 'contained' },
                    style: {
                        fontWeight: 600,
                        textTransform: 'none',
                    },
                },
            ],
        },
    },
};
export const inputProps = { sx: { borderRadius: '8px !important', color: '#1e1e1e', fontWeight: 400, fontSize: 16 } };
export const labelProps = { sx: { borderRadius: '8px !important', color: '#999999', fontWeight: 400, fontSize: 16 } };
